import "core-js/modules/es6.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import CheckboxOption from './checkbox-option';
/**
 * Block checkbox option. For backwards compatibility only, use CheckboxOption
 * directly instead.
 *
 * @deprecated
 */

var CheckboxBlock = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(CheckboxOption, _extends({
    ref: ref
  }, props, {
    inline: false
  }));
});
CheckboxBlock.displayName = 'CheckboxBlock';
export default CheckboxBlock;